<app-blog-shell [blogId]="'etl-engineering'" [darkMode]="darkMode">
  <div #entryRoot class="blog-entry">
    <h1 data-translate="BLOG.DETAILS.etl-engineering.TITLE"></h1>
    <br>

    <h2 data-translate="BLOG.DETAILS.etl-engineering.TLDR.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.etl-engineering.TLDR.BODY"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.etl-engineering.SECTION1.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION1.P1"></p>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION1.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.etl-engineering.SECTION2.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION2.P1"></p>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION2.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.etl-engineering.SECTION3.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION3.P1"></p>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION3.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.etl-engineering.SECTION4.HEADLINE"></h2>
    <ul class="unordered-list">
      <li data-translate="BLOG.DETAILS.etl-engineering.SECTION4.ITEM1"></li>
      <li data-translate="BLOG.DETAILS.etl-engineering.SECTION4.ITEM2"></li>
      <li data-translate="BLOG.DETAILS.etl-engineering.SECTION4.ITEM3"></li>
      <li data-translate="BLOG.DETAILS.etl-engineering.SECTION4.ITEM4"></li>
      <li data-translate="BLOG.DETAILS.etl-engineering.SECTION4.ITEM5"></li>
      <li data-translate="BLOG.DETAILS.etl-engineering.SECTION4.ITEM6"></li>
    </ul>

    <br>
    <h2 data-translate="BLOG.DETAILS.etl-engineering.SECTION5.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION5.P1"></p>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION5.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.etl-engineering.SECTION6.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION6.P1"></p>
    <p data-translate="BLOG.DETAILS.etl-engineering.SECTION6.P2"></p>

    <br>
    <h2 data-translate="BLOG.DETAILS.etl-engineering.CONCLUSION.HEADLINE"></h2>
    <p data-translate="BLOG.DETAILS.etl-engineering.CONCLUSION.P1"></p>
  </div>
  <br>
</app-blog-shell>
